import { render, staticRenderFns } from "./ArticleTGList.vue?vue&type=template&id=ff427a8c&"
import script from "./ArticleTGList.vue?vue&type=script&lang=js&"
export * from "./ArticleTGList.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTGList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports